import { render, staticRenderFns } from "./ModuleSingle.vue?vue&type=template&id=1614c8fa&scoped=true&"
import script from "./ModuleSingle.vue?vue&type=script&lang=js&"
export * from "./ModuleSingle.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSingle.vue?vue&type=style&index=0&id=1614c8fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1614c8fa",
  null
  
)

export default component.exports